import React from "react";
import { useLocation } from "react-router-dom";
import CookieBar from "../../common/CookieBar/CookieBar";
import FooterLogoBox from "./FooterLogoBox/FooterLogoBox";
import TrustBox from "../TrustBox/TrustBox";
import facebook from "../../../assets/images/redesign-v2/socials/facebook.svg";
import x from "../../../assets/images/redesign-v2/socials/x.svg";
import instagram from "../../../assets/images/redesign-v2/socials/instagram.svg";
import tiktok from "../../../assets/images/redesign-v2/socials/tiktok.svg";
import whatsapp from "../../../assets/images/redesign-v2/socials/whatsapp.svg";
import fundraising from "../../../assets/images/footer/logo-fundraising-regulator.png";
import "./styles.css";
import gamble from "./logo2.png";
import propertyRedressLogo from "./property-redress-logo.svg";

function Footer(props) {
  const location = useLocation();
  const [isLoadingPage, setIsLoadingPage] = React.useState(true);
  const currentYear = new Date().getFullYear();
  let isHide = true;
  const { pathname } = location;
  let payPageCheck = /pay/;
  const signIn = /basket/;
  const profile = /profile/;

  if (signIn.test(pathname) || profile.test(pathname)) {
    isHide = false;
  }
  let isPayPage = payPageCheck.test(pathname);
  const gambleSrc =
    (typeof gamble === "string" && gamble) ||
    (gamble && typeof gamble.default === "string" && gamble.default) ||
    (gamble && typeof gamble.src === "string" && gamble.src) ||
    "/assets/logo2.png";
  const onClickBegambleaware = (e) => {
    e.preventDefault();
    window.open("https://www.begambleaware.org/", "BegambleAware", "_blank");
  };

  React.useEffect(() => {
    setIsLoadingPage((prev) => !prev);
  }, []);
  return (
    <React.Fragment>
      {props.insideComponent || !isHide ? (
        <React.Fragment>
          {!isLoadingPage && <CookieBar />}
          <div className={`footerWrapper-bg footerWrapper-bg--green`}>
            <div className="footer-image-container">
              <div className="footer-image">
                <FooterLogoBox widget={props.widget} />
              </div>
            </div>
            <div className="footer__logos">
              <a
                className="footer-fundraisingregulator"
                href="https://www.fundraisingregulator.org.uk/directory/raffle-house-ltd"
                rel="nofollow"
                target="_blank"
                aria-label="fundraising regulator"
              >
                <img
                  src="https://www.fundraisingregulator.org.uk/fr-badge/7c26a59e-dca9-462a-8e9b-84b3c234f6f9/en/white"
                  alt="Fundraising Regulator badge with validation link"
                  loading="lazy"
                />
              </a>
              <div className="footer-property-redress">
                <img src={propertyRedressLogo} alt="property redress" />
              </div>
              <div className="footer__logos-right-block">
                <a
                  className="footer-begambleaware"
                  href="https://www.begambleaware.org/"
                  onClick={onClickBegambleaware}
                  aria-label="begambleaware"
                >
                  <img src={gambleSrc} alt="BeGambleAware"></img>
                </a>
                <div className="footer-property-redress">
                  <img src={propertyRedressLogo} alt="property redress" />
                </div>
              </div>
            </div>

            <div className={`containerFooter`}>
              <nav
                className={`footerWrapper ${
                  isPayPage ? "footer-wrap-not-display " : ""
                }`}
              >
                <div className="footer-list-block">
                  <h3 className="footer-list-block__heading">Raffle House</h3>
                  <ul>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL}>Home</a>
                    </li>
                    <li>
                      <a
                        href={
                          process.env.REACT_APP_BASE_URL + "/charity-raffle"
                        }
                      >
                        Our charity partners
                      </a>
                    </li>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/winners"}>
                        Our winners
                      </a>
                    </li>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/blog"}>
                        Blog
                      </a>
                    </li>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/sign-in"}>
                        Login/sign up
                      </a>
                    </li>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/about-us"}>
                        About us
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-list-block">
                  <h3 className="footer-list-block__heading">Draw</h3>
                  <ul>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/past-draws"}>
                        Past draws
                      </a>
                    </li>
                    {props.bonusDraw && (
                      <li>
                        <a
                          href={process.env.REACT_APP_BASE_URL + "/early-bird"}
                        >
                          {props.bonusDraw.profileTitle} Early Bird
                        </a>
                      </li>
                    )}

                    <li>
                      <a
                        href={process.env.REACT_APP_BASE_URL + "/subscription"}
                      >
                        Subscribe
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          process.env.REACT_APP_BASE_URL + "/refer-a-friend"
                        }
                      >
                        Refer a Friend
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-list-block">
                  <h3 className="footer-list-block__heading">Legal</h3>
                  <ul>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/legal/0"}>
                        Terms
                      </a>
                    </li>
                    <li>
                      <a href={process.env.REACT_APP_BASE_URL + "/legal/1"}>
                        Privacy
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          process.env.REACT_APP_BASE_URL + "/account-deletion"
                        }
                      >
                        Account Deletion
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="footer-contact-and-apps">
                  <div className="footer-list-block footer-list-block--contact">
                    <h3 className="footer-list-block__heading">Contact us</h3>
                    <ul>
                      <li className="contact-us-link">
                        <a href="https://wa.me/4407459071066">
                          <span className="contact-us-icon">
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.5 15.0001C13.5 15.199 13.579 15.3898 13.7197 15.5305C13.8603 15.6711 14.0511 15.7501 14.25 15.7501C14.4489 15.7501 14.6397 15.6711 14.7803 15.5305C14.921 15.3898 15 15.199 15 15.0001V13.5001C15 13.3012 14.921 13.1104 14.7803 12.9698C14.6397 12.8291 14.4489 12.7501 14.25 12.7501C14.0511 12.7501 13.8603 12.8291 13.7197 12.9698C13.579 13.1104 13.5 13.3012 13.5 13.5001V15.0001ZM13.5 15.0001C13.5 16.9892 14.2902 18.8969 15.6967 20.3034C17.1032 21.7099 19.0109 22.5001 21 22.5001M21 22.5001H22.5C22.6989 22.5001 22.8897 22.4211 23.0303 22.2805C23.171 22.1398 23.25 21.949 23.25 21.7501C23.25 21.5512 23.171 21.3604 23.0303 21.2198C22.8897 21.0791 22.6989 21.0001 22.5 21.0001H21C20.8011 21.0001 20.6103 21.0791 20.4697 21.2198C20.329 21.3604 20.25 21.5512 20.25 21.7501C20.25 21.949 20.329 22.1398 20.4697 22.2805C20.6103 22.4211 20.8011 22.5001 21 22.5001ZM4.5 31.5001L6.975 25.8001C5.08149 23.1122 4.234 19.8256 4.59157 16.5572C4.94913 13.2888 6.48718 10.2633 8.91706 8.04836C11.3469 5.83343 14.5016 4.5814 17.7891 4.52722C21.0765 4.47305 24.2707 5.62047 26.7723 7.75413C29.2738 9.8878 30.9107 12.861 31.3758 16.1159C31.8408 19.3707 31.1021 22.6834 29.2982 25.4322C27.4942 28.1811 24.7492 30.1771 21.5781 31.0457C18.407 31.9144 15.0279 31.5959 12.075 30.1501L4.5 31.5001Z"
                                stroke="#DEE965"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span className="contact-us-content">
                            <span>WhatsApp:</span>
                            <span>07459071066</span>
                          </span>
                        </a>
                      </li>
                      <li className="contact-us-link">
                        <a href="mailto:info@rafflehouse.com">
                          <span className="contact-us-icon">
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.5 10.5C4.5 9.70435 4.81607 8.94129 5.37868 8.37868C5.94129 7.81607 6.70435 7.5 7.5 7.5H28.5C29.2956 7.5 30.0587 7.81607 30.6213 8.37868C31.1839 8.94129 31.5 9.70435 31.5 10.5M4.5 10.5V25.5C4.5 26.2956 4.81607 27.0587 5.37868 27.6213C5.94129 28.1839 6.70435 28.5 7.5 28.5H28.5C29.2956 28.5 30.0587 28.1839 30.6213 27.6213C31.1839 27.0587 31.5 26.2956 31.5 25.5V10.5M4.5 10.5L18 19.5L31.5 10.5"
                                stroke="#DEE965"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span className="contact-us-content">
                            <span>Email:</span>
                            <span>info@rafflehouse.com</span>
                          </span>
                        </a>
                      </li>
                      <li className="contact-us-link social-icons-asset">
                        <ul className="social-links-list">
                          <li>
                            <a
                              href="https://www.facebook.com/RaffleHouseUK/"
                              rel="noopener"
                              target="_blank"
                            >
                              <img
                                height="24"
                                width="24"
                                src={facebook}
                                alt="facebook"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.instagram.com/RaffleHouseUK/"
                              rel="noopener"
                              target="_blank"
                            >
                              <img
                                height="24"
                                width="24"
                                src={instagram}
                                alt="instagram"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://x.com/RaffleHouseUK/"
                              rel="noopener"
                              target="_blank"
                            >
                              <img height="24" width="24" src={x} alt="x" />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.tiktok.com/@rafflehouseuk"
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              <img
                                height="24"
                                width="24"
                                src={tiktok}
                                alt="tiktok"
                              />
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="footer-contact-us-logo-list">
                  <div className="socialIcons">
                    <div className="socialIconsImages">
                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/RaffleHouseUK/"
                            rel="noopener"
                            target="_blank"
                          >
                            <img
                              height="24"
                              width="24"
                              src={facebook}
                              alt="facebook"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/RaffleHouseUK/"
                            rel="noopener"
                            target="_blank"
                          >
                            <img
                              height="24"
                              width="24"
                              src={instagram}
                              alt="instagram"
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://x.com/RaffleHouseUK/"
                            rel="noopener"
                            target="_blank"
                          >
                            <img height="24" width="24" src={x} alt="x" />
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.tiktok.com/@rafflehouseuk"
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            <img
                              height="24"
                              width="24"
                              src={tiktok}
                              alt="tiktok"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>
              <div className="companyDesc">
                <h3>About Raffle House</h3>
                <span>
                  Raffle House is a UK online prize competition company,
                  operated by Raffle House Ltd., established in 2017. Our Dream
                  Home draws are independently managed by Civica, who have over
                  30 years' experience of putting people first. We offer you the
                  chance to win a home and give to charity, and all of our
                  competitions include a free postal entry method. Regardless of
                  the method of entry, every ticket is automatically added to
                  the relevant bonus prize pools and will be entered for each
                  related competition. No purchase is necessary to enter though
                  all online entries are able to support a charitable cause
                  close to your heart. It’s time to dream big and do good. This
                  content is not intended for anyone under 18 years of age.
                </span>
              </div>
            </div>
            <div className="footer-divider-container">
              <div className="footer-divider"></div>
            </div>
            <div className="footer-sponsors-block">
              <div className="footer-copyright-wrapper">
                <a href="#" className="footer-copyright-link-desktop">
                  {`Copyright 2017-${currentYear} - Raffle House Ltd.`}
                </a>
                <a href="#" className="footer-copyright-link-desktop">
                  Company Reg. No. 10928240 - All Rights Reserved
                </a>
                <a href="#" className="footer-copyright-link-mobile left-align">
                  {`Copyright 2017-${currentYear}`}
                  <br />
                  {`Raffle House Ltd.`}
                </a>
                <a
                  href="#"
                  className="footer-copyright-link-mobile right-align"
                >
                  Company Reg. No. 10928240
                  <br />
                  All Rights Reserved
                </a>
              </div>
              <div className="socialIcons">
                <div className="socialIconsImages">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/RaffleHouseUK/"
                        rel="noopener"
                        target="_blank"
                      >
                        <img
                          height="36"
                          width="36"
                          src={facebook}
                          alt="facebook"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/RaffleHouseUK/"
                        rel="noopener"
                        target="_blank"
                      >
                        <img
                          height="36"
                          width="36"
                          src={instagram}
                          alt="instagram"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://x.com/RaffleHouseUK/"
                        rel="noopener"
                        target="_blank"
                      >
                        <img height="36" width="36" src={x} alt="x" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.tiktok.com/@rafflehouseuk"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <img height="36" width="36" src={tiktok} alt="tiktok" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}

export default Footer;
